import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BackupIcon from '@mui/icons-material/Backup';
import { Stack, Typography, Button } from "@mui/material";
import React from 'react';

interface AllPairedProps {
  onBackupZwave?: () => void;
  isBackingUp?: boolean;
}

/* Display message that all devices are paired*/
const AllPaired: React.FC<AllPairedProps> = ({ onBackupZwave, isBackingUp = false }) => (
  <Stack sx={{ alignItems: 'center', justifyContent: 'center', gap: 2 }}>
    <Typography sx={{ color: 'success.main' }}>
      <CheckCircleIcon fontSize="large" />
    </Typography>
    <Typography>
      All devices are paired.
    </Typography>
    {onBackupZwave && (
      <Button
        variant="outlined"
        color="primary"
        startIcon={<BackupIcon />}
        onClick={onBackupZwave}
        disabled={isBackingUp}
      >
        {isBackingUp ? 'Backing Up Z-Wave NVRAM...' : 'Backup Z-Wave NVRAM'}
      </Button>
    )}
  </Stack>
);

export default AllPaired;